
const state = {
  charts: [],
  requests: []
}

const compactChart = (observer) => {
  const compact = {}
  const chart = { ...observer }
  delete chart.data

  for (const key in chart) {
    if (!chart.hasOwnProperty(key)) {
      continue
    }

    if (typeof (chart[key]) === 'function') {
      continue
    }

    if (typeof (chart[key]) === 'object') {
      compact[key] = compactChart(chart[key])
      continue
    }

    compact[key] = chart[key]
  }

  return compact
}

const storeCharts = (charts) => {
  if (!charts || charts.length === 0) {
    localStorage.removeItem('analytics.charts')
    return
  }

  localStorage.setItem('analytics.charts', JSON.stringify(charts.map(observer => compactChart(observer))))
}

const mutations = {
  setCharts (state, { charts }) {
    state.charts = charts
  },

  addChart (state, { chart }) {
    state.charts = [...state.charts, chart]
    storeCharts(state.charts)
  },

  updateChart (state, { id, cache }) {
    const charts = [...state.charts]
    const index = charts.findIndex(c => c.id === id)
    if (index === -1) {
      return
    }

    charts[index] = {
      ...charts[index],
      cache
    }

    state.charts = charts
  },

  removeChart (state, { id }) {
    state.charts = [...state.charts].filter(c => c.id !== id)
    storeCharts(state.charts)
  },

  addRequest (state, { request }) {
    state.requests.push(request)
  },

  setRequests (state, { requests }) {
    state.requests = requests
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
